<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="ma-2">
        <v-card elevation="6">
          <div class="pa-4">
            <QuotationNumber :quotation_code="header_list.order_code" :quotation_date="header_list.created_date"/>
            <div class="mt-4">
              <div class="grid_contact">
                <div class="grid_flex mt-2">
                  <div class="mr-2">เบอร์โทร</div>
                  <div>{{ header_list.telephone }}</div>
                </div>
                <div class="grid_flex mt-2">
                  <div class="mr-2">ชื่อลูกค้า</div>
                  <div>{{ header_list.name }}</div>
                </div>
              </div>
              <div class="grid_contact">
                <div class="grid_flex mt-2">
                  <div class="mr-2">ที่อยู่</div>
                  <div>{{ header_list.address }}</div>
                </div>
              </div>
              <div class="grid_address mt-2">
                <div>
                  <div>ตำบล/แขวง</div>
                  <div class="grey--text">{{ header_list.sub_district_delivery }}</div>
                </div>
                <div>
                  <div>อำเภอ/เขต</div>
                  <div class="grey--text">{{ header_list.district_delivery }}</div>
                </div>
                <div>
                  <div>จังหวัด</div>
                  <div class="grey--text">{{ header_list.province_delivery }}</div>
                </div>
                <div>
                  <div>รหัสไปรษณีย์</div>
                  <div class="grey--text">{{ header_list.postcode_delivery }}</div>
                </div>
              </div>
              <div class="grid_contact">
                <div class="grid_flex mt-2">
                  <div class="mr-2">การจัดส่ง</div>
                  <div class="grey--text">{{ header_list.delivery_type == 1 ? 'ส่งพัสดุ' : 'รับที่ร้าน'}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pa-4">
            <v-card-title>
              รายการสินค้า
            </v-card-title>
            <div v-if="loading_data === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-data-table :headers="headers" :items="data_list" key="index" :footer-props="footer_Props" mobile-breakpoint="0">
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td class="text-center">{{ dataDetail.index + 1 }}</td>
                    <td class="pa-3">
                      <div>{{ dataDetail.item.name }}</div>
                      <div v-for="(data, index) in dataDetail.item.order_list_detail" :key="index">
                        <small class="pl-3">- {{ data.product_name }} ({{ data.qty }} {{ data.unit_name }})</small>
                      </div>
                    </td>
                    <td>
                      <div v-if="dataDetail.item.unit_name">{{ dataDetail.item.unit_name }}</div>
                      <div v-else>-</div>
                    </td>
                    <td v-if="$route.params.type == 0">
                      <div v-if="dataDetail.item.qty !== null">{{ number_format(dataDetail.item.qty) }}</div>
                      <div v-else>-</div>
                    </td>
                    <td v-else-if="$route.params.type == 1">
                      <div v-if="dataDetail.item.quantity !== null">{{ number_format(dataDetail.item.quantity) }}</div>
                      <div v-else>-</div>
                    </td>
                    <td>{{ format_price(dataDetail.item.cost) }}</td>
                    <td>{{ format_price(dataDetail.item.total) }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="5" class="text-center">ค่าจัดส่ง</td>
                    <td>{{ format_price(header_list.delivery_price) }}</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="text-center">จำนวนเงินรวม</td>
                    <td>{{ format_price(header_list.total) }}</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import QuotationNumber from "@/components/admin/stock/quotation/header_quotation/QuotationNumber";
import {HTTP} from "@/axios";
import {formatNumber, formatPrice} from "@/js/handler";
export default {
  components: {QuotationNumber},
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Quotation_detail_shop",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      address_split: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          align: 'center',
          width: '140px',
        },
        {
          text: 'รายละเอียดสินค้า',
          value: 'product_name',
          fixed: true,
          width: '350px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วยละ',
          value: 'cost',
          fixed: true,
          width: '170px',
        },
        {
          text: 'จำนวนเงิน',
          value: 'total',
          fixed: true,
          width: '170px',
        },
      ],
      header_list: [],
      data_list: [],
    }
  },
  methods: {
    number_format: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    async get_data() {
      this.loading_page = true
      await HTTP.post('/quotations/quotationretaildetail', {
        order_code: this.$route.params.id,
        type: this.$route.params.type,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.object
          this.data_list = res.data.object.orderlists
          // let address_spl = res.data.object.delivery_address.split(",")
          // this.address_split = address_spl
          // let address_cut = address_spl[0]
          // address_cut.split("")
        }
      })
    },
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_flex {
  display: flex;
}
.grid_contact {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_address {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
@media only screen and (max-width: 500px) {
  .grid_flex {
    display: block;
  }
  .grid_contact {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_address {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
}
</style>
